import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import Hyphenated from 'react-hyphen';

import Utils from './../Utils';
import ReferencePopup from './ReferencePopup';

const BORDER_WIDTH_REM = '0.05';

const LINK_SATURATION = '45%';
const LINK_BG_LUMINANCE = '90%';
const LINK_OL_LUMINANCE = '75%';

const ReferenceLink = styled.span`
    cursor: pointer;
    padding: 0 0.15rem
    border-radius: 0.15rem;
    margin-left: -0.15rem;
    color: black;
    opacity: 0.55;
    &:hover {
        opacity: 1.0;
    }
`;

const FormatItalic = styled.span`
    font-style: italic;
`;

export class ReferenceFormat extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired,
        on_reference_click: PropTypes.func.isRequired,
        references: PropTypes.object.isRequired
    }

    state = {
        in_popup: false,
        popup_x: 0,
        popup_y: 0,
        popup_text: '',
        popup_hue: 0,
        popup_title: '',
        popup_subject: '',
        fade_interval: null,
        hover_interval: null
    };

    popup_link = (e, reference_index) => {
        const {references} = this.props;
        const reference_data = references[reference_index]
        const popup_text = reference_data.detail.items ?
            reference_data.detail.items.declaration.value : reference_data.text;
        this.setState({
            in_popup: true,
            popup_x: e.clientX + window.scrollX - 20,
            popup_y: e.clientY + window.scrollY + 20,
            popup_text: popup_text,
            popup_hue: reference_data.hue,
            popup_subject: reference_data.subject,
            popup_title: reference_index
        })
    }

    format_link(text, reference_index) {
        const {references} = this.props;
        const reference = references[reference_index];
        if (!reference) {
            console.log("reference is bad", reference)
            return <span>bad link: {text}</span>
        }
        const random_key = reference_index + '-' + Utils.random_int(100000);

        const link_style = {
            border: `${BORDER_WIDTH_REM}rem solid hsla(${reference.hue}, ${LINK_SATURATION}, ${LINK_OL_LUMINANCE})`,
            backgroundColor: `hsl(${reference.hue},${LINK_SATURATION},${LINK_BG_LUMINANCE})`
        }
        const reference_ref = React.createRef();
        const reference_link = <ReferenceLink
            ref={reference_ref}
            style={link_style}
            key={random_key}
            title={`click to learn more about ${reference_index}`}
            onClick={e => this.popup_link(e, reference_index)}>{this.italic(text)}
        </ReferenceLink>
        return reference_link;
    }

    italic = text => {
        const italic = /__(.*?)__/gim;
        return text.split(italic).map((s, i) => {
            const hyphenated = <Hyphenated key={"rf_" + Utils.random_int()}>{s}</Hyphenated>
            return i % 2 ? <FormatItalic key={"italic_" + i}>{hyphenated}</FormatItalic> : hyphenated
        })
    }

    render() {
        const {in_popup, popup_x, popup_y, popup_text, popup_hue, popup_title, popup_subject} = this.state;
        const {text, on_reference_click} = this.props;
        const result = [];
        const reference = /~~(.*?):(.*?)~~/gim;
        const parts = text.split(reference)
        parts.forEach((p, i) => {
            switch (i % 3) {
                case 0:
                    result.push(this.italic(p));
                    break;
                case 1:
                    const link = this.format_link(p, parts[i + 1])
                    result.push(link);
                    break;
                default:
                    break;
            }
        });
        const popup = <ReferencePopup
            title={popup_title}
            text={popup_text}
            x={popup_x}
            y={popup_y}
            hue={popup_hue}
            subject={popup_subject}
            close_popup={() => this.setState({in_popup: false})}
            on_reference_click={reference => on_reference_click(reference)}/>
        return <span>
            {result}
            {in_popup && (popup)}
        </span>;
    }
}

export default ReferenceFormat;
